// Homepage Scripts
(function() {
  'use strict';

  const header = document.querySelector('.l-header');

  if (header) {
    const navigation = document.querySelector('.nav--primary');

    window.onscroll = function() {
      const scrollpos = window.scrollY;

      if (scrollpos > 0) {
        header.classList.remove('is-top-home');
        navigation.lastElementChild.previousElementSibling.classList.remove(
          'button--reverse'
        );
      } else {
        header.classList.add('is-top-home');
        navigation.lastElementChild.previousElementSibling.classList.add(
          'button--reverse'
        );
      }
    };
  }
})();
